import { render, staticRenderFns } from "./materials-table.component.vue?vue&type=template&id=293dc5a4&"
import script from "./materials-table.component.ts?vue&type=script&lang=ts&"
export * from "./materials-table.component.ts?vue&type=script&lang=ts&"
import style0 from "./materials-table.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
